/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-01-08 19:25:52
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'

import BsyFilterBase from '../BsyFilterBase';
import './index.css'
import BsySelect from '../../BsySelect';
import { BsyUtils } from '../../../utils/Utils';
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterApp extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            ...props
        })

        this.dashText = null;
    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.EQ]
    }

    getValue = () => {
        if (this.dashText) {
            return this.dashText.getValue()

        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
    }

    componentDidMount() {
        super.componentDidMount()
        this._loadApps();

    }

    _loadApps = () => {
        let that = this;
        React.axios("/dashboard/app_group/list", {}).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {

                var i = [];
                if(that.props.mode === "externalFlow"){
                    res.data.dock_items && BsyUtils.forEach(res.data.dock_items, function (t, a) {
                        if((that.props.corpId || that.props.corpId == 0) && that.props.corpId === a._id){
                            BsyUtils.forEach(a.apps, function (t1, a1) {
                                i.push({
                                    value: a1._id,
                                    text: a1.appname,
                                })
                            })
                        }
                    })
                }else{
                    BsyUtils.forEach(res.data.items, function (t, a) {
                        BsyUtils.forEach(a.apps, function (t1, a1) {
                            i.push({
                                value: a1._id,
                                text: a1.appname,
                            })
                        })
                    })
                }

                this.setState({
                    items: [...i]
                })
            })

        }).catch(res => {
            console.error(res);
        })
    }


    renderCont = () => {
        let e = this
        let i = this.options;

        let val = this.getMiddleValue() || {};

        return <BsySelect
            theme={this.props.theme}
            hasLimit={!0}
            allowBlank={true}
            items={this.state.items}
            height={'34px'}
            value={val}
            onStopEdit={e1 => {
                e.value = e.getValue()
                BsyUtils.applyFunc(e, i.onStopEdit, [{
                    value: e.getValue(),
                    valueMode: e.valueMode,
                    method: e.method,
                }, i], !1)
            }}
            getContext={this.getContext}
        />

    }

    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

